// extracted by mini-css-extract-plugin
module.exports = {"resourceWrapper":"new_resourceWrapper__3Q3W9","heading":"new_heading__39M_P","subHeading":"new_subHeading__1sZT0","mainHeading":"new_mainHeading__33z5l","lists":"new_lists__3Kdu0"};